export const generateAvatarUrl = (email: string): string => {
  return `https://api.dicebear.com/7.x/avatars/svg?seed=${encodeURIComponent(email)}&backgroundColor=b6e3f4,c0aede,d1d4f9&radius=50`;
};